module.exports = __webpack_public_path__ + "img/company-logo.7e9c0a45.svg";